import React, { useState } from "react"

import * as S from "./catering.styles"
import Container from "@mui/material/Container"
import { Typography } from "@mui/material"
import { contactFormApi } from "../../apis/contact-api"
import CustomTextField from "../../components/custom-text-field/custom-text-field.component"
import { useForm } from "react-hook-form"
import Grid from "@mui/material/Grid"
import DateFnsUtils from "@date-io/date-fns" // choose your lib
import {
  DatePicker,
  TimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers"
import { getWordpressToken } from "../../utils"

const Catering = ({ text }) => {
  const parse = require("html-react-parser")

  const { register, handleSubmit, errors, control } = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
  })

  const [isLoading, setIsLoading] = useState(false)
  const [successMessage, setSuccessMessage] = useState("")
  const [selectedDate, handleDateChange] = useState(new Date())

  const onSubmit = async data => {
    setIsLoading(true)

    const form = new FormData()
    form.append("contactName", data.contactName)
    form.append("address", data.address)
    form.append("mobilePhone", data.mobilePhone)
    form.append("email", data.email)
    form.append("company", data.company)
    form.append("date", data.date)
    form.append("time", data.time)
    form.append("comments", data.comments)

    const token = await getWordpressToken()

    return await contactFormApi
      .post("/183/feedback", form, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data" },
      })
      .then(response => {
        setIsLoading(false)
        if (response?.data?.message) {
          setSuccessMessage(response.data.message)
        } else {
          setSuccessMessage("Please try again later!")
        }
      })
  }

  return (
    <S.Wrapper>
      <Container maxWidth="md">
        {text && <div className="wrapper">{parse(text)}</div>}

        <S.CustomForm onSubmit={handleSubmit(onSubmit)}>
          {isLoading && (
            <S.FormSpinner>
              <S.CustomSpinner />
            </S.FormSpinner>
          )}
          {!successMessage ? (
            <Container maxWidth="sm">
              <div>
                <label>
                  Contact Name<sup>*</sup>
                </label>
                <CustomTextField
                  name="contactName"
                  isRequired
                  register={register}
                  errors={errors}
                />
              </div>
              <div>
                <label>
                  Address<sup>*</sup>
                </label>
                <CustomTextField
                  name="address"
                  isRequired
                  register={register}
                  errors={errors}
                />
              </div>
              <div>
                <label>
                  Mobile Phone<sup>*</sup>
                </label>
                <CustomTextField
                  type="number"
                  name="mobilePhone"
                  isRequired
                  register={register}
                  errors={errors}
                />
              </div>
              <div>
                <label>
                  Email<sup>*</sup>
                </label>
                <CustomTextField
                  type="email"
                  name="email"
                  errors={errors}
                  register={register}
                  isRequired
                />
              </div>
              <div>
                <label>
                  Company<sup>*</sup>
                </label>
                <CustomTextField
                  name="company"
                  isRequired
                  register={register}
                  errors={errors}
                />
              </div>
              <Grid container className="date-time">
                <Grid item xs={6}>
                  <label>
                    Date<sup>*</sup>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <DatePicker
                      value={selectedDate}
                      onChange={handleDateChange}
                      format="MM/dd/yyyy"
                      disablePast
                      allowKeyboardControl
                      name="date"
                      inputRef={register}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <Grid item xs={6}>
                  <label>
                    Hour<sup>*</sup>
                  </label>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <TimePicker
                      value={selectedDate}
                      onChange={handleDateChange}
                      name="time"
                      inputRef={register}
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
              </Grid>

              <div className="comments">
                <label>
                  Comments<sup>*</sup>
                </label>
                <textarea name="comments" ref={register} />
              </div>

              <S.Button className="red" type="submit" fullWidth>
                Send Request
              </S.Button>
            </Container>
          ) : (
            <S.SuccessMessage>
              <Typography>{successMessage}</Typography>
            </S.SuccessMessage>
          )}
        </S.CustomForm>
      </Container>
    </S.Wrapper>
  )
}

export default Catering
